import React from "react"
import styled from "styled-components"

import {
    Button,
    Input,
    FormGroup,
    ChevronDownIcon,
    ChevronUpIcon,
} from "client/components"

export const ChevronButton = styled(Button)`
    height: 33px;
    margin-bottom: 8px;
    margin-right: 0;
    padding: 0 12px;
    min-width: unset;

    & > i {
        font-size: 12px;
    }
`
export const ChevronInput = styled(Input)`
    width: calc(100% - 36px * 2); // where "36px" is the width of ChevronButton
`

export interface IncreaseInputProps {
    onChange: (val: number) => void
    value: number
}

export const IncreaseInput = ({
    onChange,
    value,
}: IncreaseInputProps) => (
    <FormGroup inline>
        <ChevronButton onClick={() => onChange(value > 0 ? value - 1 : 0)}>
            <ChevronDownIcon />
        </ChevronButton>
        <ChevronInput type="text" value={value} readOnly />
        <ChevronButton onClick={() => onChange(value < 10 ? value + 1 : 10)}>
            <ChevronUpIcon />
        </ChevronButton>
    </FormGroup>
)
